/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CertificationStageTypeDto = {
    Survey: 'SURVEY',
    Test: 'TEST',
    Exam: 'EXAM',
    DevelopmentCenter: 'DEVELOPMENT_CENTER',
    Plan: 'PLAN'
} as const;

export type CertificationStageTypeDto = typeof CertificationStageTypeDto[keyof typeof CertificationStageTypeDto];



